import { useEffect, useState } from 'react';

let id = 0;
const genId = () => ++id;

export const useId = () => {
  const [id, setId] = useState(null);
  useEffect(() => setId(genId()), []);
  return id;
};
